<template>
  <section class="section container pt-3">
    <div class="columns">
      <div class="column is-4">
        <deployment-list ref="deployment_list" @select="select_deployment" />
      </div>
      <div class="column">
        <deployment-manager ref="deployment_manager" />
      </div>
    </div>
  </section>
</template>

<script>
import DeploymentList from "./DeploymentList.vue";
import DeploymentManager from "./DeploymentManager.vue";

export default {
  name: "NgineManagerIndex",
  components: { DeploymentList, DeploymentManager },
  data() {
    return {};
  },
  methods: {
    select_deployment(deployment) {
      this.$refs.deployment_manager.load_deployment(deployment);
    },
  },
  mounted() {
    this.$refs.deployment_list.refresh();
  },
  created() {},
};
</script>

<style scoped></style>
